export function configCheck() {
  let url = "user/v1/auth/user_status";
  return {
    types: [
      `CONFIG_CHECK_PENDING`,
      `CONFIG_CHECK_FULFILLED`,
      `CONFIG_CHECK_REJECTED`,
    ],
    method: "GET",
    url,
    service: "trnzOpenApi",
  };
}
